<app-card>
  <form [formGroup]="searchForm">
    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'common.date.start' | translate }}</label>
          <input type="date" appInput autofocus formControlName="startDate">
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'common.date.end' | translate }}</label>
          <input type="date" appInput formControlName="endDate">
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.wholesale.balancesupplieridentification' | translate }}</label>
          <select appSelect [collection]="balanceSupplierList" formControlName="balanceSupplierIdentification">
          </select>
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.wholesale.meteringpointtype' | translate }}</label>
          <select appSelect [collection]="meteringPointTypeList" formControlName="typeOfMeteringPoint">
          </select>
        </app-input-group>
      </div>
    </div>
    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.wholesale.settlementmethod' | translate }}</label>
          <select appSelect [collection]="settlementMethodList" formControlName="settlementMethod">
          </select>
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.wholesale.chargetype' | translate }}</label>
          <select appSelect [collection]="chargeTypeList" formControlName="chargeType">
          </select>
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.wholesale.chargetypeid' | translate }}</label>
          <input type="text" appInput formControlName="chargeTypeId" [placeholder]="('common.define' | translate) + ' ' + ('settlement.wholesale.chargetypeid' | translate)">
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.wholesale.chargeowner' | translate }}</label>
          <select appSelect [collection]="chargeOwnerEnergyPartyList" formControlName="chargeOwnerEnergyParty">
          </select>
        </app-input-group>
      </div>
    </div>
    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.wholesale.businessreasoncode' | translate }}</label>
          <select appSelect [collection]="businessReasonCodeList" formControlName="businessReasonCode">
          </select>
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.wholesale.processvariant' | translate }}</label>
          <select appSelect [collection]="processVariantList" formControlName="processVariant">
          </select>
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'settlement.wholesale.datahubstatus' | translate }}</label>
          <select appSelect [collection]="dataHubStatusList" formControlName="dataHubStatus">
          </select>
        </app-input-group>
      </div>
      <div class="w-1/4"></div>
    </div>
    <div>
      <button appButton (click)="table.search()">{{ 'common.search' | translate }}</button>
    </div>
  </form>
</app-card>

<app-table
  #table
  [config]="tableConfig"
  [(selectedElements)]="selectedElements"
></app-table>
